import { useMutation } from '@apollo/client';
import { SAVE_USER_LAST_LOGIN } from 'api/mutations';


export const useSaveUserLastLogin = () => {
  const [saveLastLogin, { data, loading, error }] = useMutation(SAVE_USER_LAST_LOGIN);
  return { saveLastLogin, isSuccess: !!data?.saveUserLastLogin, isLoading: loading, error };
}
